var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEye = function SvgEye(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35 8.03067C0.783333 7.29467 0.5 6.926 0.5 5.83333C0.5 4.74 0.783333 4.37267 1.35 3.636C2.48133 2.16667 4.37867 0.5 7.16667 0.5C9.95467 0.5 11.852 2.16667 12.9833 3.636C13.55 4.37333 13.8333 4.74067 13.8333 5.83333C13.8333 6.92667 13.55 7.294 12.9833 8.03067C11.852 9.5 9.95467 11.1667 7.16667 11.1667C4.37867 11.1667 2.48133 9.5 1.35 8.03067Z",
    stroke: "#E5B42F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16669 5.8335C9.16669 6.36393 8.95597 6.87264 8.5809 7.24771C8.20583 7.62278 7.69712 7.8335 7.16669 7.8335C6.63625 7.8335 6.12755 7.62278 5.75247 7.24771C5.3774 6.87264 5.16669 6.36393 5.16669 5.8335C5.16669 5.30306 5.3774 4.79436 5.75247 4.41928C6.12755 4.04421 6.63625 3.8335 7.16669 3.8335C7.69712 3.8335 8.20583 4.04421 8.5809 4.41928C8.95597 4.79436 9.16669 5.30306 9.16669 5.8335Z",
    stroke: "#E5B42F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye.4b04439ee2d1059d3df765511f73391e.svg";